/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsDentalPage = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsDentalPage = $.extend(this, window.PXUTheme.getSectionData($section));

    this.container = $section[0];

    this.documentDelegate = new domDelegate.Delegate(document.body);
    this.documentDelegate.on("click", "[data-scroll-to-form]", this.scrollToForm.bind(this));

    this.form = this.container.querySelector("[data-scroll-anchor]");
  },
  scrollToForm: function(event,target) {
    event.preventDefault();
    let test = this.form.offsetTop - 100;

    window.scroll({
      top:test,
      behavior: 'smooth'
    })

  },
  unload: function($section) {
  }
}

/******/ })()
;